/**
 * Management Storage Configuration
 *
 * Centralized storage keys and utilities for management module
 */
// Storage keys
export const STORAGE_KEYS = {
    MANAGEMENT_CONFIG: '__PELLE_MANAGEMENT_CONFIG__',
    SELECTED_SECTION: '__PELLE_MANAGEMENT_SELECTED_SECTION__',
    AUTH_TOKEN: '__PELLE_MANAGEMENT_AUTH_TOKEN__',
    ORGANIZATIONS: '__PELLE_MANAGEMENT_ORGANIZATIONS__'
};
/**
 * Get item from localStorage
 * @param key - Storage key
 * @returns Storage value or null
 */
export const getStorageItem = (key) => {
    if (typeof window === 'undefined')
        return null;
    return localStorage.getItem(key);
};
/**
 * Set item to localStorage
 * @param key - Storage key
 * @param value - Value to store
 */
export const setStorageItem = (key, value) => {
    if (typeof window === 'undefined')
        return;
    localStorage.setItem(key, value);
};
/**
 * Remove item from localStorage
 * @param key - Storage key
 */
export const removeStorageItem = (key) => {
    if (typeof window === 'undefined')
        return;
    localStorage.removeItem(key);
};
/**
 * Get JSON item from localStorage
 * @param key - Storage key
 * @returns Parsed JSON object or null
 */
export const getStorageJSON = (key) => {
    const item = getStorageItem(key);
    if (!item)
        return null;
    try {
        return JSON.parse(item);
    }
    catch (e) {
        console.error(`Error parsing storage item ${key}:`, e);
        return null;
    }
};
/**
 * Set JSON item to localStorage
 * @param key - Storage key
 * @param value - Value to store (will be stringified)
 */
export const setStorageJSON = (key, value) => {
    setStorageItem(key, JSON.stringify(value));
};
